// Das Zeichen "neuer Tab" haengt am Ende eines Linktexts (DESIGN B10, B17).
// REINES MODELL, kein React.
//
// Ein Wortverbinder hielt das Zeichen nicht: es ist ein eigenstaendiges
// Inline-Element, vor dem der Browser umbrechen darf. Darum steht das letzte
// Stueck des Texts mit dem Zeichen in einem Block ohne Umbruch. Bei einem Text
// ohne Leerzeichen (eine Website-Adresse) sind es nur die letzten Zeichen, damit
// eine lange Adresse bei 320 px weiter umbricht.

const OHNE_LEERZEICHEN_HALTEN = 6;

/**
 * Teilt den Linktext in den Teil, der umbrechen darf, und den, der beim Zeichen bleibt.
 * Gezaehlt wird in Graphemen, nicht in UTF-16-Einheiten: ein Emoji oder ein Buchstabe
 * mit Akzentzeichen wird nie zerteilt (Codex-P2 #819).
 */
export function textVorNeuerTab(text: string): { readonly vorne: string; readonly hinten: string } {
  const leer = text.lastIndexOf(' ');
  if (leer >= 0) return { vorne: text.slice(0, leer + 1), hinten: text.slice(leer + 1) };
  const teile = [...new Intl.Segmenter('de', { granularity: 'grapheme' }).segment(text)].map((stueck) => stueck.segment);
  const schnitt = Math.max(0, teile.length - OHNE_LEERZEICHEN_HALTEN);
  return { vorne: teile.slice(0, schnitt).join(''), hinten: teile.slice(schnitt).join('') };
}
